import { darken } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { BUTTON_INTENT, BUTTON_VARIANT, Button } from 'components/Button'
import Icon from 'components/Icon'
import { Toast } from 'components/Toast'
import { useUserAuth } from 'providers/userAuth'
import { COLOR_INTENT } from 'Theme'
import {
  useAddCollectionProductMutation,
  useExpertShowroomCollectionCollectionItemQuery,
  useRemoveCollectionProductMutation,
} from 'types/graphql-generated'

const StyledButton = styled(Button)`
  &:hover {
    background-color: ${darken(0.05, COLOR_INTENT.ERROR_LIGHT)} !important;
  }
`

interface ShowroomButtonProps {
  productId: number
  productVariantId: number
}

export const ShowroomButton: React.FC<React.PWC<ShowroomButtonProps>> = ({
  productId,
  productVariantId,
}) => {
  const { user } = useUserAuth()
  const {
    data,
    loading: isCollectionItemQueryLoading,
    refetch,
  } = useExpertShowroomCollectionCollectionItemQuery({
    variables: {
      productVariantId,
    },
  })
  const [
    removeCollectionProductMutation,
    { loading: isRemoveMutationLoading },
  ] = useRemoveCollectionProductMutation()
  const [addCollectionProductMutation, { loading: isAddMutationLoading }] =
    useAddCollectionProductMutation()

  const isLoading =
    isCollectionItemQueryLoading ||
    isRemoveMutationLoading ||
    isAddMutationLoading

  return (
    <>
      {data?.expertShowroomCollectionCollectionItem ? (
        <StyledButton
          variant={BUTTON_VARIANT.FILLED}
          icon={Icon.Cross}
          backgroundColor={COLOR_INTENT.ERROR_LIGHT}
          intent={BUTTON_INTENT.DANGER}
          isLoading={isLoading}
          onClick={async () => {
            const response = await removeCollectionProductMutation({
              variables: {
                input: {
                  collectionId: user.expert?.expertShowroomCollection?.id,
                  productId,
                  productVariantId,
                },
              },
            })
            if (!response.errors) {
              Toast.success('Product removed successfully')
              refetch()
            }
          }}
        >
          Remove from my showroom
        </StyledButton>
      ) : (
        <Button
          variant={BUTTON_VARIANT.FILLED}
          icon={Icon.Plus}
          isLoading={isLoading}
          onClick={async () => {
            const response = await addCollectionProductMutation({
              variables: {
                input: {
                  collectionId: user.expert?.expertShowroomCollection?.id,
                  productId,
                  productVariantId,
                  positionIndexWeight: 99999,
                },
              },
            })
            if (!response.errors) {
              Toast.success('Product added successfully')
              refetch()
            }
          }}
        >
          Add to my showroom
        </Button>
      )}
    </>
  )
}
